module.exports = __webpack_public_path__ + "img/public/SiteIcons/viewCarsIconNew.svg?16d194f9";